<div class="sms-verification-section" *ngIf="isUserDisabled">
    <p class="theme-paragraph" *ngIf="!showSmsSection">{{ "Didn't receive email?" | translate }}</p>

    <button
        *ngIf="!showSmsSection && showToggle && !smsOrgCapHit"
        (click)="toggleSmsSection()"
        class="btn-primary btn-full-width theme-button button-center"
        type="button"
        apxButton
        variant="primary"
        porAddFeature
        featureName="sms-verification-use-sms">
        {{ 'Use phone verification instead' | translate }}
    </button>

    <p *ngIf="smsOrgCapHit && smsMessage" class="sms-status-message error-message">{{ smsMessage }}</p>

    <div *ngIf="showSmsSection" class="sms-form">
        <p class="theme-paragraph">{{ 'We will send a verification code to your registered phone number.' | translate }}</p>

        <button
            (click)="sendSmsCode()"
            [disabled]="smsSending || smsDisabled"
            class="btn-primary btn-full-width theme-button mb-sm"
            type="button"
            apxButton
            variant="primary"
            porAddFeature
            featureName="sms-verification-send-sms">
            {{ smsSending ? ('Sending...' | translate) : ('Send code to phone' | translate) }}
        </button>

        <p *ngIf="smsMessage" class="sms-status-message" [ngClass]="{ 'success-message': smsMessage.includes('sent'), 'error-message': !smsMessage.includes('sent') }">
            {{ smsMessage }}
        </p>

        <button
            *ngIf="showEmailToggle"
            (click)="toggleSmsSection()"
            class="btn-primary btn-full-width theme-button button-center"
            type="button"
            apxButton
            variant="primary"
            porAddFeature
            featureName="sms-verification-use-email">
            {{ 'Use email verification instead' | translate }}
        </button>
    </div>
</div>
